import { moduleIds } from '@/hooks/useFeatures';
import { SUPPORT_PORTAL_URL } from '@/constants/support';
import React from 'react';
import {
  FiUsers,
  FiUser,
  FiUserCheck,
  FiUserPlus,
  FiAlertTriangle,
  FiClock,
  FiCamera,
  FiMonitor,
  // FiGlobe,
  FiCalendar,
  FiBell,
  FiEdit3,
  FiFileText,
  FiCoffee,
  FiInbox,
  FiSettings,
  FiCreditCard,
  FiFolder,
  FiCheckSquare,
  FiBriefcase,
  FiMail,
  FiZap,
  FiDownload,
  FiUploadCloud,
  FiHelpCircle,
  FiTrash2,
} from 'react-icons/fi';

// Sidebar nav items are grouped for display by `section`. This is purely a
// rendering concern — access control (moduleId/role filtering in NavItem.jsx)
// still runs over the flat teamReportItems/managementItems arrays first, so
// adding/reordering sections here never touches who can see what.
export const sidebarSections = {
  overview: 'Overview',
  monitor: 'Monitor & Analyze',
  management: 'Management',
  administration: 'Administration',
};

export const teamReportItems = [
  {
    id: 'department-dashboard',
    title: 'Department Dashboard',
    type: 'item',
    navLink: '/department-dashboard',
    section: 'overview',
    icon: FiUsers,
  },
  {
    id: 'user-dashboard',
    moduleId: moduleIds.DASHBOARD_OVERVIEW,
    title: 'User Dashboard',
    type: 'item',
    navLink: '/user-dashboard',
    section: 'overview',
    icon: FiUser,
  },

  {
    id: 'alerts',
    moduleId: moduleIds.PRODUCTIVITY_ALERT,
    title: 'Productivity Alert',
    type: 'item',
    navLink: '/alerts',
    section: 'overview',
    icon: FiAlertTriangle,
  },
  {
    id: 'late-early-login-alerts',
    moduleId: moduleIds.LATE_EARLY_LOGIN_ALERT,
    title: 'Late & Early Alerts',
    type: 'item',
    navLink: '/late-early-login-alerts',
    section: 'overview',
    icon: FiClock,
  },
  {
    id: 'timeline',
    moduleId: moduleIds.TIMELINE,
    title: 'Timeline',
    type: 'item',
    navLink: '/timeline',
    section: 'monitor',
    icon: FiClock,
  },
  {
    id: 'screenshots',
    moduleId: moduleIds.SCREENSHOTS,
    title: 'Screenshots',
    type: 'item',
    navLink: '/screenshots',
    section: 'monitor',
    icon: FiCamera,
  },
  {
    id: 'app-usage',
    moduleId: moduleIds.APP_USAGE,
    title: 'App Usage',
    type: 'item',
    navLink: '/app-usage',
    section: 'monitor',
    icon: FiMonitor,
  },
  // {
  //   id: 'url-tracking',
  //   moduleId: moduleIds.URL_TRACKING,
  //   title: 'URL Tracking',
  //   type: 'item',
  //   navLink: '/url-tracking',
  //   section: 'monitor',
  //   icon: FiGlobe,
  // },
  // {
  //   id: 'teams-timeline',
  //   moduleId: moduleIds.TEAMS_TIMELINE,
  //   title: "Department's Timeline",
  //   type: 'item',
  //   navLink: '/teams-timeline',
  //   section: 'monitor',
  //   icon: FiActivity,
  // },
  // {
  //   id: 'teams-reporting',
  //   moduleId: moduleIds.TEAMS_REPORTING,
  //   title: "Department's Reporting",
  //   type: 'item',
  //   navLink: '/teams-reporting',
  // },
  // {
  //   id: "team-attendance",
  //   title: "Team Attendance",
  //   type: "item",
  //   navLink: "/team-attendance",
  //
  // },
  {
    id: 'user-attendance',
    moduleId: moduleIds.USER_ATTENDANCE,
    title: 'User Attendance',
    type: 'item',
    navLink: '/userAttendance',
    section: 'monitor',
    icon: FiCalendar,
  },
  {
    id: 'notifications',
    moduleId: moduleIds.NOTIFICATIONS,
    title: 'Notifications',
    type: 'item',
    navLink: '/notifications',
    section: 'monitor',
    icon: FiBell,
  },
];
export const managementItems = [
  {
    id: 'regularization',
    moduleId: moduleIds.REGULARIZATION,
    title: 'Regularization',
    type: 'item',
    navLink: '/regularization',
    section: 'management',
    icon: FiEdit3,
  },
  {
    id: 'requests',
    moduleId: moduleIds.REQUESTS_REGULARIZATION,
    title: 'Regularization requests',
    type: 'item',
    navLink: '/requestsregularization',
    section: 'management',
    icon: FiFileText,
  },
  {
    id: 'leave',
    moduleId: moduleIds.LEAVE,
    title: 'Leave',
    type: 'item',
    navLink: '/leave',
    section: 'management',
    icon: FiCoffee,
  },
  {
    id: 'leaverequest',
    moduleId: moduleIds.LEAVE_REQUESTS,
    title: 'Leave requests',
    type: 'item',
    navLink: '/requestsleave',
    section: 'management',
    icon: FiInbox,
  },
  {
    id: 'profile',
    title: 'Profile',
    type: 'item',
    navLink: '/profile',
    section: 'management',
    icon: FiUserCheck,
  },
  {
    id: 'settings',
    moduleId: moduleIds.SETTINGS,
    title: 'Settings',
    type: 'item',
    navLink: '/manage-settings',
    section: 'administration',
    icon: FiSettings,
  },
  {
    id: 'billing',
    title: 'Invoices',
    type: 'item',
    navLink: '/invoices',
    section: 'administration',
    icon: FiCreditCard,
  },
  {
    id: 'projects',
    moduleId: moduleIds.PROJECTS,
    title: 'Projects',
    type: 'item',
    navLink: '/project',
    section: 'management',
    icon: FiFolder,
  },
  {
    id: 'tasks',
    moduleId: moduleIds.TASKS,
    title: 'Tasks',
    type: 'item',
    navLink: '/manage-tasks',
    section: 'management',
    icon: FiCheckSquare,
  },
  {
    id: 'add-employee',
    moduleId: moduleIds.ADD_EMPLOYEE,
    title: 'Add User',
    type: 'item',
    navLink: '/add-user',
    section: 'management',
    icon: FiUserPlus,
  },
  {
    id: 'employee-list',
    moduleId: moduleIds.EMPLOYEE_LIST,
    title: 'Employees',
    type: 'item',
    navLink: '/employee-list',
    section: 'management',
    icon: FiUsers,
  },
  {
    id: 'team-list',
    moduleId: moduleIds.TEAM_LIST,
    title: 'Departments',
    type: 'item',
    navLink: '/departments',
    section: 'management',
    icon: FiBriefcase,
  },
  {
    id: 'invitations-hub',
    moduleId: moduleIds.INVITATIONS,
    title: 'Invitations',
    type: 'item',
    navLink: '/invitations-hub',
    section: 'management',
    icon: FiMail,
  },
  {
    id: 'integrations',
    title: 'Integrations',
    type: 'item',
    navLink: '/integrations',
    section: 'administration',
    icon: FiZap,
  },
  {
    id: 'download-desktop-app',
    title: 'App Downloads',
    type: 'item',
    navLink: '/download-desktop-app',
    section: 'administration',
    icon: FiDownload,
  },
  {
    id: 'uninstall-guide',
    title: 'Uninstall Guide',
    type: 'item',
    navLink: '/uninstall-guide',
    section: 'administration',
    icon: FiTrash2,
  },
  {
    // Staff-only — filtered out for everyone except a hardcoded uid in
    // NavItem.jsx (search 'app-version-publish'). Not a general access-control
    // field on this item; do not add a moduleId/role expecting it to apply here.
    id: 'app-version-publish',
    title: 'App Versions',
    type: 'item',
    navLink: '/app-version-publish',
    section: 'administration',
    icon: FiUploadCloud,
  },
  {
    id: 'support-portal',
    title: 'Support',
    type: 'item',
    external: true,
    navLink: SUPPORT_PORTAL_URL,
    section: 'administration',
    icon: FiHelpCircle,
  },
];
